import {
  Box,
  Button,
  Img,
  Input,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { BsFillCameraFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../../context/getUserProfile";
import { useGetState } from "../../context/useGetState";
import { createGroups } from "./tradingGroup/service";
import axios from "axios";
import { errorNotifier, successNotifier } from "../..";
import http, { AUTH_ROUTES } from "../../service/api";
import { useEffect } from "react";

function CreateGroup() {
  const { state } = useGetState();
  const { userInfo } = state;
  const imgRef = useRef(null);
  const [img, setImg] = useState(null);
  const initValues = {
    name: "",
    trial_period: "",
    price: "0",
    description: "",
    category: "",
    group_access: "",
  };
  const [formValues, setFormValues] = useState(initValues);
  const [previewImg, setPreviewImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectPlan, setSelectPlan] = useState("free");
  const [nameExists, setNameExists] = useState(false);
  const [paidPlans, setPaidPlans] = useState([]);
  const [categories, setCategories] = useState([]);

  const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
  const inputBgColor = useColorModeValue("#fff", "#081b2e");
  const textColor = useColorModeValue("#697C94", "#697C94");
  const navigate = useNavigate();
  const account_type = userInfo?.account_type;

  // convert file to a base64 url
  const readURL = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };

  const inputStyles = {
    p: "25px",
    borderRadius: "10px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    w: "100%",
    fontSize: ".9em",
    color: "#697C94",
  };

  useEffect(() => {
    async function fetchCategories() {
      const res = await http.get(AUTH_ROUTES.GET_GROUP_CATEGORIES);
      setCategories(res?.data);
    }
    fetchCategories();
  }, []);

  // Get the bearer token from sessionStorage
  const token = sessionStorage.getItem("#f8WEB#");
  // console.log('token: ', token);

  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  //sameName logic
  let timer;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "group_access") {
      console.log('group_access: ', value);
      setFormValues((prev) => ({ ...prev, group_access: value }));
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    }
  };
  

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));

    // Check if the change occurred in the "name" input field
    // if (name === "group_name") {
    //   // Clear the previous timer
    //   clearTimeout(timer);

    //   // Set a new timer to make the API call after a delay (e.g., 3000 milliseconds)
    //   timer = setTimeout(() => {
    //     // Make an Axios call to check if the group name exists
    //     axios.get(`https://f8.codester.dev/api/groups?search=${value}`, { headers })
    //       .then((response) => {
    //         // Check if the group name exists in the database based on the API response
    //         //const doesNameExist = response.data.some((group) => group.name === value);
    //         const doesNameExist = response?.data == true ? true : false;
    //         console.log("doesNameExist:", doesNameExist);
    //         setNameExists(doesNameExist);
    //       })
    //       .catch((error) => {});
    //   }, 3000); // Adjust the delay as needed
    // }
  };
  //end of same logic

  // Create a function to update the plans array based on changes in plan input fields
  const handlePaidPlanChange = (index, field, value) => {
    // Clone the current plans array to avoid mutating state directly
    const updatedPaidPlans = [...paidPlans];

    // Check if the plan object at the specified index exists, and create one if not
    if (!updatedPaidPlans[index]) {
      updatedPaidPlans[index] = { id: index + 1, price: 0 }; // Initialize with id and default price
    }

    // Update the specified field of the plan object
    updatedPaidPlans[index][field] = value;

    // Update the state with the updated plans array
    setPaidPlans(updatedPaidPlans);
  };
  //console.log('setPaidPlans: ', paidPlans.length);

  const handleSubmitForm = async () => {
    setLoading(true);

    const formData = new FormData();

    formData.append("picture", img);
    formData.append("name", formValues?.group_name);
    formData.append("description", formValues?.description);
    formData.append("group_category_id", formValues?.category);
    formData.append("group_access", formValues?.group_access);
    formData.append("type", selectPlan);

    //filter and append paid plans
    if (paidPlans.length > 0) {
      // Filter plans with non-zero prices
      const filteredPlans = paidPlans.filter((plan) => plan.price > 0);
      // Append filtered plans to the FormData
      filteredPlans.forEach((plan, index) => {
        formData.append(`plans[${index}][id]`, plan.id);
        formData.append(`plans[${index}][price]`, plan.price);
      });
    }

    const createNewGroupUrl = "https://f8.codester.dev/api/groups";

    try {
      // Make the Axios call with headers
      const response = await axios.post(createNewGroupUrl, formData, {
        headers,
      });
      console.log("response: ", response);
      if (response) {
        setFormValues(initValues);
        setLoading(false);
        successNotifier("Group created successfully");
        navigate("/groups");
      }

      // ... Further processing of response
    } catch (error) {
      errorNotifier(error.response?.data?.message);
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <Stack direction={"row"} spacing="50px" pr="60px">
      <Stack flex="1">
        {img ? (
          <Stack
            position={"relative"}
            maxW="200px"
            maxH="150px"
            objectFit={"cover"}
            w="200px"
            h="150px"
            cursor={"pointer"}
            onClick={() => imgRef.current.click()}
          >
            <Img
              w="200px"
              h="150px"
              objectFit={"cover"}
              src={previewImg}
              alt="profile pic"
            />
            <BsFillCameraFill
              fontSize={"1.5em"}
              style={{
                position: "absolute",
                transform: "translate(90px, 50px)",
              }}
            />
          </Stack>
        ) : (
          <Stack
            w="200px"
            h="150px"
            borderRadius={"10px"}
            bg="#707070"
            py="20px"
            justifyContent={"center"}
            alignItems="center"
            color="#fff"
            cursor={"pointer"}
            onClick={() => imgRef.current.click()}
          >
            <BsFillCameraFill fontSize={"1.5em"} />
            <Text fontSize={".8em"} textAlign="center">
              Click to change
              <br /> Image
            </Text>
          </Stack>
        )}
      </Stack>
      <Input
        type="file"
        ref={imgRef}
        accept="image/jpg, image/jpeg, image/png"
        display={"none"}
        onChange={async (e) => {
          setImg(e.target.files?.[0]);
          setPreviewImg(await readURL(e.target.files?.[0]));
        }}
      />
      <Stack
        flex="4"
        bg={containerBgColor}
        borderRadius={"15px"}
        p="20px"
        alignItems={"center"}
      >
        <Stack maxW="400px" w="350px" spacing={"25px"}>
          <Input
            placeholder="Group Name"
            type="text"
            name="group_name"
            value={formValues?.group_name}
            onChange={handleChange}
            {...inputStyles}
          />
          {nameExists && (
            <p style={{ color: "red" }}>This group name already exists.</p>
          )}

          <Textarea
            rows={"4"}
            resize="none"
            placeholder="Describe Your Group..."
            name="description"
            value={formValues?.description}
            onChange={handleChange}
            {...inputStyles}
          />
          <style>{`
          .chakra-select__wrapper{
            background: ${inputBgColor};
            box-shadow: 3px 8px 13px 0px #8080800f;
            border-radius: 10px;
            padding: 10px;
          }
          `}</style>
          <Select
            default="forex"
            fontSize={".9em"}
            name="category"
            onChange={handleChange}
            _placeholder={{ color: "#f2f2f2" }}
            {...inputStyles}
            boxShadow="none"
            defaultValue={"default"}
          >
            <option disabled value="default" color="#718096">
              Group Category
            </option>
            {categories?.length > 0 &&
              categories.map((cat, index) => (
                <option key={index} value={cat.id} style={{ color: "#718096" }}>
                  {cat.name}
                </option>
              ))}
          </Select>

          <Select
            fontSize={".9em"}
            name="group_access"
            onChange={handleChange}
            _placeholder={{ color: "#f2f2f2" }}
            {...inputStyles}
            boxShadow="none"
            defaultValue={"default"}
          >
            <option disabled value="default" color="#718096">
              Select Privacy
            </option>
            <option value="public" style={{ color: "#718096" }}>
                Public
            </option>
            <option value="private" style={{ color: "#718096" }}>
                Private
            </option>
          </Select>

          <Stack direction={"row"} alignItems="center">
            <Text
              cursor={"pointer"}
              {...inputStyles}
              p="20px"
              {...(selectPlan === "free" ? inputStyles : {})}
              fontSize="initial"
              color={selectPlan === "free" && "#fff"}
              bg={selectPlan === "free" && "grey"}
              onClick={() => setSelectPlan("free")}
            >
              Free
            </Text>
            <Text
              {...inputStyles}
              p="20px"
              cursor="pointer"
              {...(selectPlan === "free" ? inputStyles : {})}
              fontSize="initial"
              color={selectPlan === "paid" && "#fff"}
              bg={selectPlan === "paid" && "grey"}
              onClick={() => setSelectPlan("paid")}
              fontWeight="medium"
            >
              Paid
            </Text>
          </Stack>

          {selectPlan === "paid" && (
            <>
              <Input
                type={"text"}
                placeholder="Free trial period(optional)"
                disabled={selectPlan === "free"}
                {...inputStyles}
                name="trial_period"
                value={formValues?.trial_period}
                onChange={handleChange}
              />

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 23px 12px 23px",
                  borderRadius: "10px",
                  boxShadow: "3px 8px 13px 0px #8080800f",
                  backgroundColor: inputBgColor,
                  width: "100%", // Adjust the width as needed
                  fontSize: ".9em",
                  color: textColor,
                }}
              >
                <div style={{ flex: 1 }}>
                  <Input
                    placeholder="$"
                    type="number"
                    variant="unstyled"
                    style={{
                      width: "100%",
                      padding: "0", // Remove default padding
                      border: "none", // Remove default border
                      outline: "none", // Remove default outline
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      handlePaidPlanChange(0, "price", value);
                    }}
                  />
                </div>
                <div>
                  {/* You can add an icon or caret here */}
                  Monthly plan(optional)
                </div>
              </Box>

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 23px 12px 23px",
                  borderRadius: "10px",
                  boxShadow: "3px 8px 13px 0px #8080800f",
                  backgroundColor: inputBgColor,
                  width: "100%", // Adjust the width as needed
                  fontSize: ".9em",
                  color: textColor,
                }}
              >
                <div style={{ flex: 1 }}>
                  <Input
                    placeholder="$"
                    type="number"
                    variant="unstyled"
                    style={{
                      width: "100%",
                      padding: "0", // Remove default padding
                      border: "none", // Remove default border
                      outline: "none", // Remove default outline
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      handlePaidPlanChange(1, "price", value);
                    }}
                  />
                </div>
                <div>
                  {/* You can add an icon or caret here */}
                  Yearly plan(optional)
                </div>
              </Box>

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 23px 12px 23px",
                  borderRadius: "10px",
                  boxShadow: "3px 8px 13px 0px #8080800f",
                  backgroundColor: inputBgColor,
                  width: "100%", // Adjust the width as needed
                  fontSize: ".9em",
                  color: textColor,
                }}
              >
                <div style={{ flex: 1 }}>
                  <Input
                    placeholder="$"
                    type="number"
                    variant="unstyled"
                    style={{
                      width: "100%",
                      padding: "0", // Remove default padding
                      border: "none", // Remove default border
                      outline: "none", // Remove default outline
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      handlePaidPlanChange(2, "price", value);
                    }}
                  />
                </div>
                <div>
                  {/* You can add an icon or caret here */}
                  Lifetime (optional)
                </div>
              </Box>
            </>
          )}

          <Button
            color="#fff"
            h="50px"
            w="250px"
            bg="#50BB69"
            _hover={{ background: "#50BB69" }}
            alignSelf={"center"}
            borderRadius="15px"
            isLoading={loading}
            onClick={handleSubmitForm}
          >
            Create Group
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default CreateGroup;
